module.exports = __webpack_public_path__ + "img/5.6b56dfd9.svg";